import { h } from 'preact';

const SwatchSelector = ({
  option,
  optionId,
  productId,
  handleVariantChange,
  selectedOption,
  isQuickView
}) => (
  <div>
    <span htmlFor={optionId} className="block text-body-2 font-medium">
      {option.name}
      <span className="inline-block ml-2.5 text-body-2 text-grey-7">
        {selectedOption?.value}
      </span>
    </span>
    {option.values.length > 1 && (
      <div className="flex flex-wrap mt-2 mb-5 lg:mt-3.5">
        {option.values.map((value, index) => (
          <div
            key={`${optionId}-${value}`}
            className={`relative flex items-center 
          w-[21px] h-[21px] rounded-full border mr-5 lg:mr-2.5 cursor-pointer ${
            selectedOption?.value === value ? ' border-black' : 'border-grey-3'
          }`}
            style={{
              backgroundColor: option?.swatches
                ? option.swatches[index]
                : value,
            }}
          >
            <input
              type="radio"
              id={`${isQuickView ? 'qw' : ''}${productId}-${value.replace(' ', '')}`}
              name={`${productId}-${option.name}`}
              value={value}
              checked={selectedOption?.value === value}
              onChange={handleVariantChange}
              data-option-name={option.name}
              className="absolute left-[1.5px] opacity-0 cursor-pointer focus:opacity-100 focus:outline-none focus:ring-1 focus:ring-offset-4 focus:ring-black focus:text-transparent focus:bg-none focus:bg-transparent bg-transparent focus:!border-black w-[21px] h-[21px] top-[-1px] left-[-1px]"
            />
            <label htmlFor={`${isQuickView ? 'qw' : ''}${productId}-${value.replace(' ', '')}`}>
              <span className="sr-only">{value}</span>
            </label>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default SwatchSelector;
